import React, { useContext } from "react";
import { Box, CircularProgress } from "@mui/material";
import SimResultsList from "../components/SimResultsList";
import { ResultsContext } from "../ResultsContext";
import useFetchImgs from "../useFetchImgs";
import { TIFFViewer } from "react-tiff";

const AutoListPage = () => {
  const { autoResults, filteredAutoResults, setFilteredAutoResults } =
    useContext(ResultsContext);

  return (
    <Box sx={{ p: 2, border: 0, justifyContent: "center", display: "flex" }}>
      <SimResultsList
        type_of_claim={"Auto"}
        data={filteredAutoResults}
        setFilteredResults={setFilteredAutoResults}
        originalData={autoResults}
      />
    </Box>
  );
};

export default AutoListPage;
